// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"231":"comparison","535":"login","729":"dataReport","900":"dataReports","919":"indexView"}[chunkId] + ".1742565780354.js";
};